module.exports = __webpack_public_path__ + "static/media/Report.1c586e70.svg";